import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, unref as _unref, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37cd343c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "block-wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "选配件信息", -1))
const _hoisted_4 = { class: "list-info" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "载机平台", -1))
const _hoisted_6 = { class: "tag-item" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "block-wrap"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "标配产品", -1))
const _hoisted_10 = { class: "list-info" }
const _hoisted_11 = { class: "label" }
const _hoisted_12 = { class: "tag-item adaptation-item" }
const _hoisted_13 = {
  key: 1,
  class: "block-wrap"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "选配产品", -1))
const _hoisted_15 = { class: "list-info" }
const _hoisted_16 = { class: "label" }
const _hoisted_17 = { class: "tag-item adaptation-item" }
const _hoisted_18 = ["onClick", "data-disabled"]
const _hoisted_19 = { class: "statics-info van-hairline--bottom" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "零售价:", -1))
const _hoisted_21 = { class: "price-text-info" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  required: ""
}, "购机数量", -1))
const _hoisted_23 = { class: "" }
const _hoisted_24 = { class: "price-info-wrap" }
const _hoisted_25 = {
  key: 0,
  class: "take-down-tips"
}
const _hoisted_26 = { class: "total-wrap" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "合计金额：", -1))
const _hoisted_28 = { class: "price-text-info" }

import { useRouter, useRoute } from 'vue-router'
import { Form, Field, FieldRule, Button } from 'vant'
import { commonErrorHandle } from '@/utils/error-handle'
import { clearToast, showToastLoading, times } from '@/utils/tools'
import { usePageSelectionInfo } from '@/compositions/agricultura-loan'
import { ConfirmUsePackageInfoStorage } from '@/storage/agricultura-loan'
import { computed, onMounted, Ref, ref, withDefaults } from 'vue'
import {
  ProductSelectionItem,
  ProductSelectionDetailResponse,
  StandardProduct,
  OptionalAccessoriesItem,
  CombinationInfoItemsIdKey,
} from '@/types/agricultura-loan'
import AppHeader from '@/components/Header.vue'
import CommonFooterWrap from '@/components/CommonFooterWrap.vue'

interface OptionalAccessoriesGroupItemType {
  type: number
  typeText: string
  checkid?: number
  list: OptionalAccessoriesItem[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'package-selection',
  setup(__props) {

const formVm = ref()
const $router = useRouter()
const $route = useRoute()
const numPlaceholder = '请输入购机数量'
const currentPackageDetail: Ref<null | ProductSelectionDetailResponse> = ref(null)
const packageSelectionsData: Ref<ProductSelectionItem[]> = ref([])
const deviceNum = ref($route.query.num as string)
const selectedPackageGuid = ref(($route.query.selectionGuid as string) || '')
const { getPackageSelections, getPackageDetail } = usePageSelectionInfo()

const uuid = ($route.query.uuid || '') as string

// 标准产品数组
const standardsProducts: Ref<StandardProduct[]> = ref([])
// 选配产品信息
const optionalAccessories: Ref<OptionalAccessoriesItem[]> = ref([])
// 选配组信息
const optionalAccessoriesGroups: Ref<OptionalAccessoriesGroupItemType[]> = ref([])
// 是否为编辑, 编辑时 产品选配不应该更改
const isEdit = !!uuid
const deviceNumFules: FieldRule[] = [
  { required: true, message: numPlaceholder },
  {
    validator: (value) => {
      value = Number(value)
      return Number.isInteger(value) && value > 0
    },
    message: '请输入正整数',
  },
]
// 匹配到的套餐数据
const relateItem = computed(() => {
  const isAllCheck = optionalAccessoriesGroups.value.every((item) => item.checkid)
  if (!isAllCheck) {
    return null
  }
  const relate = currentPackageDetail.value?.relate
  if (!relate) {
    return null
  }
  for (let i = 0; i < relate.length; i++) {
    const isMatch = optionalAccessoriesGroups.value.every((item) => {
      const key: CombinationInfoItemsIdKey = `items_id_${item.type}`
      const value = item.checkid
      return relate[i]?.[key] === value
    })
    if (isMatch) {
      // 匹配则返回金额
      return relate[i]
    }
  }
  return null
})
// 是否未已下架的产品
const isMatchTakeDown = computed(() => {
  // return relateItem.value?.product_info?.status === 2 || relateItem.value?.status === 2
  return false
})
// 是否未已禁用的产品
// 选配零售价
const optionalProductPrice = computed(() => {
  return relateItem.value?.product_info?.price44 || 0
})
// 选配总价
const optionalTotalPrice = computed(() => {
  const price = optionalProductPrice.value
  return times(Number(price), Number(deviceNum.value || 0), 2)
})
// 当前已选中的套装
const currentSelectePackage = computed(() => {
  return packageSelectionsData.value?.filter((item) => item.guid === selectedPackageGuid.value)[0]
})

// 更新选项是否可选的状态
function updateGroupOptionsDisabledStatus() {
  optionalAccessoriesGroups.value.forEach((groupItem) => {
    const selectedTypeIds: { [key in CombinationInfoItemsIdKey]?: number } = {}
    optionalAccessoriesGroups.value.forEach((item) => {
      if (item.type !== groupItem.type && item.checkid) {
        const key: CombinationInfoItemsIdKey = `items_id_${item.type}`
        selectedTypeIds[key] = item.checkid
      }
    })
    const canUseMap = checkOptimizer(selectedTypeIds)
    groupItem.list.forEach((optionItem) => {
      const canUseIds = canUseMap[`items_id_${groupItem.type}`]
      if (canUseIds && canUseIds.length) {
        // 有可选项限制
        if (canUseIds.includes(optionItem.id)) {
          optionItem.disabled = false
        } else {
          optionItem.disabled = true
        }
      } else {
        // 无限制全部可选
        optionItem.disabled = false
      }
    })
  })
}

// 标配产品分组
const standardsProductGroups = computed(() => {
  const products = standardsProducts.value || []
  const groupsDataMap: Record<
    string,
    {
      type: string | number
      typeText: string
      list: StandardProduct[]
    }
  > = {}
  products.forEach((item) => {
    if (groupsDataMap[item.type]) {
      groupsDataMap[item.type].list.push(item)
    } else {
      groupsDataMap[item.type] = {
        type: item.type,
        typeText: item.type_text,
        list: [item],
      }
    }
  })
  const data = Object.keys(groupsDataMap).map((type) => {
    const result = groupsDataMap[type]
    return result
  })
  return data
})

// 加载载机平台数据
async function initPackageSelections() {
  showToastLoading()
  try {
    const list = await getPackageSelections()
    packageSelectionsData.value = list
    clearToast()
    if (selectedPackageGuid.value) {
      // 代表编辑进来的情况，需要加载选中的详情数据
      confirmPackageItem(selectedPackageGuid.value)
    }
  } catch (error) {
    console.log('error', error)
    commonErrorHandle(error)
  }
}
// 确认选择载机平台
function confirmPackageItem(guid: string) {
  selectedPackageGuid.value = guid
  initPackageDetailInfo(guid)
}

//

// 加载详情数据
async function initPackageDetailInfo(guid: string) {
  showToastLoading()
  try {
    const data = await getPackageDetail(guid)
    currentPackageDetail.value = data
    renderPackageDetailInfo(data)
    clearToast()
  } catch (error) {
    commonErrorHandle(error)
  }
}
// 选配产品选中
function setTagItemCheckGuid(
  optionItem: OptionalAccessoriesItem,
  groupItem: OptionalAccessoriesGroupItemType
) {
  if (optionItem.disabled) {
    return
  }
  if (isEdit) {
    // 编辑状态不可更改选项
    return
  }
  if (groupItem.checkid === optionItem.id) {
    // 取消选中
    groupItem.checkid = undefined
  } else {
    groupItem.checkid = optionItem.id
  }
  updateGroupOptionsDisabledStatus()
  // groupItem.checkid = optionItem.id
  // console.log('groupItem', groupItem)
}

// 计算可选项是否可选

/**
 * 创建预计算查询器（针对固定数组的性能优化版本）
 * @param {Array} dataArray - 固定的数据数组
 * @returns {Function} - 返回查询函数
 */
function createQueryOptimizer(
  dataArray: Array<{
    [key: CombinationInfoItemsIdKey]: number
  }>
) {
  if (!dataArray.length) {
    return () => ({})
  }

  // 预计算：获取所有属性类型
  const allTypes = Object.keys(dataArray[0]).filter(
    (key) => key.indexOf('items_id') === 0
  ) as CombinationInfoItemsIdKey[]
  // 预计算：构建索引映射
  const indexMap = new Map()

  // 为每个记录构建所有可能的查询键
  dataArray.forEach((record) => {
    // 为每个可能的属性子集创建索引
    for (let mask = 1; mask < 1 << allTypes.length; mask++) {
      const selectedTypes: string[] = []
      const keyParts = []

      // 根据掩码选择属性
      for (let i = 0; i < allTypes.length; i++) {
        if (mask & (1 << i)) {
          const type = allTypes[i]
          selectedTypes.push(type)
          keyParts.push(`${type}:${record[type]}`)
        }
      }

      // 创建索引键
      const key = keyParts.sort().join('|')

      if (!indexMap.has(key)) {
        indexMap.set(key, new Map())
      }

      const resultMap = indexMap.get(key)

      // 记录其他属性的值
      allTypes.forEach((type) => {
        if (!selectedTypes.includes(type)) {
          if (!resultMap.has(type)) {
            resultMap.set(type, new Set())
          }
          resultMap.get(type).add(record[type])
        }
      })
    }
  })
  /**
   * 优化的查询函数（O(1) 时间复杂度）
   * @param {Object} input - 输入的type和id值
   * @returns {Object} - 返回其他type可用的id数组
   */
  return function optimizedQuery(input: { [key: CombinationInfoItemsIdKey]: number }) {
    const inputTypes = Object.keys(input) as CombinationInfoItemsIdKey[]
    if (inputTypes.length === 0 || inputTypes.length === allTypes.length) {
      return {}
    }

    // 创建查询键
    const key = inputTypes
      .map((type: CombinationInfoItemsIdKey) => {
        return `${type}:${input[type]}`
      })
      .sort()
      .join('|')

    // 从预计算索引中获取结果
    const resultMap: any = indexMap.get(key)
    if (!resultMap) {
      return {}
    }

    // 转换为结果对象
    const result: { [key: CombinationInfoItemsIdKey]: number[] } = {}
    resultMap.forEach((valueSet: any, type: any) => {
      result[type] = Array.from(valueSet) as number[]
    })

    return result
  }
}
let checkOptimizer: (input: { [key: `items_id_${number}`]: number }) => {
  [key: `items_id_${number}`]: number[]
} = () => {
  return {}
}
// 渲染详情数据
async function renderPackageDetailInfo(data: ProductSelectionDetailResponse) {
  standardsProducts.value = data.standards
  optionalAccessories.value = data.items
  const groupsTypeMap: Record<string | number, OptionalAccessoriesGroupItemType> = {}
  const relateId = Number($route.query.relateId as string)
  const relateItem = currentPackageDetail.value.relate.filter((item) => item.id === relateId)[0]
  optionalAccessories.value.forEach((item) => {
    const { type, type_text } = item
    if (!groupsTypeMap[type]) {
      groupsTypeMap[type] = {
        type,
        typeText: type_text,
        checkid: relateItem?.[`items_id_${type}`] || 0,
        list: [{ ...item, disabled: false }],
      }
    } else {
      groupsTypeMap[type].list.push({ ...item, disabled: false })
    }
  })
  optionalAccessoriesGroups.value = Object.keys(groupsTypeMap).map((key) => {
    return groupsTypeMap[key]
  })
  checkOptimizer = createQueryOptimizer(currentPackageDetail.value.relate)
}

function confirmHandle() {
  formVm.value?.submit()
}

// 确定选择
function submitHandle() {
  ConfirmUsePackageInfoStorage.set({
    uuid,
    code: relateItem.value?.product_info?.material_code, // 产品物料编码
    productName: currentSelectePackage.value.product_name,
    num: Number(deviceNum.value),
    standardsProducts: standardsProducts.value,
    optionalAccessories: optionalAccessoriesGroups.value.map((groupItem) => {
      return groupItem.list.filter((item) => item.id === groupItem.checkid)[0]
    }),
    relateItem: relateItem.value,
  })
  $router.go(-1)
}

onMounted(() => {
  initPackageSelections()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "购机型号" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", null, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packageSelectionsData.value, (item) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(item.guid === selectedPackageGuid.value ? 'tag-active' : ''),
                  key: item.guid,
                  onClick: ($event: any) => (confirmPackageItem(item.guid))
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.name), 1)
                ], 10, _hoisted_7)), [
                  [_vShow, isEdit ? item.guid === selectedPackageGuid.value : true]
                ])
              }), 128))
            ])
          ])
        ])
      ]),
      (standardsProducts.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("ul", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(standardsProductGroups), (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.type
                }, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(item.typeText), 1),
                  _createElementVNode("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (listItem) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "tag-active",
                        key: listItem.product_guid
                      }, [
                        _createElementVNode("span", null, _toDisplayString(listItem?.product_info?.name) + " x" + _toDisplayString(listItem?.num || 1), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (optionalAccessories.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("ul", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionalAccessoriesGroups.value, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.type
                }, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(item.typeText), 1),
                  _createElementVNode("div", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (tagItem, index) => {
                      return _withDirectives((_openBlock(), _createElementBlock("div", {
                        key: tagItem.relate_guid + index,
                        onClick: ($event: any) => (setTagItemCheckGuid(tagItem, item)),
                        "data-disabled": tagItem.disabled ? '1' : '0',
                        class: _normalizeClass(tagItem.id === item.checkid ? 'tag-active' : '')
                      }, [
                        _createElementVNode("span", null, _toDisplayString(tagItem.name) + "x" + _toDisplayString(tagItem.num || 1), 1)
                      ], 10, _hoisted_18)), [
                        [_vShow, isEdit ? tagItem.id === item.checkid : true]
                      ])
                    }), 128))
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(CommonFooterWrap, { class: "footer-content van-hairline--top" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", null, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, "￥" + _toDisplayString(_unref(optionalProductPrice)), 1)
          ]),
          _createVNode(_unref(Form), {
            class: "nongfu-field-placeholder-wrap form-wrap",
            ref_key: "formVm",
            ref: formVm,
            onSubmit: submitHandle
          }, {
            default: _withCtx(() => [
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_unref(Field), {
                  modelValue: deviceNum.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((deviceNum).value = $event)),
                  type: "digit",
                  placeholder: `${numPlaceholder}（必填）`,
                  rules: deviceNumFules,
                  class: "field-item"
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ]),
            _: 1
          }, 512)
        ]),
        _createElementVNode("div", _hoisted_24, [
          (_unref(isMatchTakeDown))
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, "套装已下架，请重新选择套装"))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", null, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, "￥" + _toDisplayString(_unref(optionalTotalPrice)), 1)
            ]),
            _createVNode(_unref(Button), {
              class: "confirm-button xa-vant-button",
              disabled: _unref(isMatchTakeDown) || !_unref(relateItem) || Number(_unref(optionalTotalPrice)) <= 0,
              round: "",
              onClick: confirmHandle
            }, {
              default: _withCtx(() => [
                _createTextVNode("确定")
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})